import React from 'react';
import cc from 'classcat';

const Loader = ({ className }) => {
    return (
        <div className={cc(['loader', className])}>
            <div className="loader__emulate-loader">
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    );
};

export default Loader;
